module.exports = __webpack_public_path__ + "static/img/meiti11.8dbb7cfa.png";